import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const pelletHardness = {
    jpath: ['spectra', 'pelletHardness'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default pelletHardness;
//# sourceMappingURL=pelletHardness.js.map